import styled from "styled-components";

export const WarningContainer = styled.div`
  display: flex;
  gap: 5px;
  line-height: 1.1rem;
`;
